import { MatStepper } from '@angular/material';

export interface WizardStep {
  valid: boolean;
  completed: boolean;
  isInit: boolean;
  activate(): void;
  save(): void;
}


export class Wizard {

  selectedIndex = 0;
  private steps: WizardStep[] = [];
  private stepper: MatStepper;

  constructor() { }

  initialize() {
    if (this.steps[this.selectedIndex].isInit) {
      this.steps[this.selectedIndex].activate();
    }
  }

  configure(steps: WizardStep[], stepper: MatStepper) {
    this.steps = steps;
    this.stepper = stepper;
  }

  next() {
    this.stepper.next();
  }

  previus() {
    this.stepper.previous();
  }

}

